<template>
  <div>
      <header>
          <div class="headerOne">
             <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
              <span class="buss">{{msg}}</span>
          </div>
      </header>
       <div class="juzhong"></div>
      <ul id="ulOne">
          <li :style="{ 'background-image': 'url(' +bgSrc + ')','background-repeat':'no-repeat','background-size':'cover' }">
              <img src="../../assets/images/lone.png" alt="">
              <span class="card">{{cShowName}}</span>
              <div :class=" 'discount' +cardStyleId  ">
                  <span class="vip">{{vipNameOne}}</span>
                  <div class="cententOne" v-if="isZhekou">
                     <span class="number">{{zhekou}}</span>
                     <span class="result">折</span>
                  </div>
                 
              </div>
               <!-- 卡号 -->
                <div class="cardNumber">{{showIDPrefix}} {{cShowId}}</div>
          </li>
      </ul>
      <div class="payment">支付好友共享此卡优惠</div>
      <div class="share">
         <!-- <div>
             <span>好友名称</span>
             <input type="text" placeholder="请输入" v-model="name" maxlength="20">
          </div>  -->
           <div class="myFriend">
             <span>好友手机号</span>
             <input type="text" placeholder="请输入11位手机号" v-model="phone" maxlength="11">
          </div> 
          <div class="remind">提醒:好友将共享该卡的余额以及积分</div>
      </div>
      
        <mt-popup v-model="popupVisible2" popup-transition="popup-fade" class="mint-popup-2" :modal="false" v-if="sendTne">
                   <p id="panduan" v-text="msgOne"></p>
        </mt-popup>
        <div class="inviteOne" @click="sure">邀 请</div>
        <div class="people">共享此卡好友</div>
        <div class="noneOne">
            <ul v-if="haveOne">
               <li>暂无其他好友共用此会员卡</li>
            </ul>
            <ul class="newUl" v-if="!haveOne">
              <li v-for="(item,index) in invit" :key="index">
                <div>
                  <span class="rightOne">好友昵称:{{item.nick}}</span>
                  <!-- <span class="right">17612102736</span> -->
                </div>
                <div>
                  <span>{{item.time}}</span>
                  <span class="right">邀请成功</span>
                </div>
              </li>
            </ul>
         </div>
  </div>
</template>
<script>

import md5 from 'js-md5';
import { DatetimePicker, Popup,  Indicator, Radio,MessageBox ,Toast } from "mint-ui";
import axios from "axios"
export default {
 
  data() {
    return {
        sendTne: true,
      isZhekou: true,
        popupVisible2: false,
      msg: this.$route.query.msg,
      msgOne:"",
      name: "",
      phone: "",
      zhekou: this.$route.query.zhekou,
      cShowName: this.$route.query.cShowName,
      showIDPrefix: this.$route.query.showIDPrefix,
      cShowId: this.$route.query.cShowId,
      vipNameOne: this.$route.query.vipNameOne,
      haveOne:true,
      invit:[],
      fid:"",
      nick:"",
      time:"",
      value:"",
      Toast: Toast({
          message: '加载中...',
          position: 'middle',
          duration: -1
        }),
       cardStyleId:localStorage.getItem('cardStyleId'),
         bgSrc:"" ,
      // checkAll: false,
      // checkedCities: ['共享积分', '共享余额'],
      // cities: ['共享积分', '共享余额'],
      // isIndeterminate: true
    };
  },
     computed:{
        phoneNum(){
           let phoneNum =this.$store.state.phoneNum
            return phoneNum
          },
            wsWbsocket(){
                return this.$store.state.wsWbsocket;
                }
        },
        
            watch: {
              popupVisible2(val) {
                if (val) {
                  setTimeout(() => {
                    this.popupVisible2 = false;
                  }, 800);
                }
              }
        
            },
 
  methods: {
       checkHttpReturn(id)
        {
                    if(httpSendQue[id]==0)
                    {
                        var  self=this;
                        setTimeout(() => {
                                if (self && !self._isDestroyed)
                                    self.checkHttpTimeOut();
                            }, newConfigTime);

                    }
                    else
                    {
                        delete httpSendQue[id];
                    }
                },
        checkHttpTimeOut()
        {
            if(httpSendQue[id]==0)
            {
                //  隐藏加载中
                  this.Toast.close()
                  Toast({
                        message: '网络不给力',
                        position: 'middle',
                        duration: 3000
                      })
                  

            }
            else
            {
                //删除数组中的id
                delete httpSendQue[id];

            }
        },
       websocketTne(){
             var newCid=this.$route.query.cidNew;
             var  self=this;     
              id= getHttpSendId ();
              getArry(id)   //将生成ID放入数组  
              setTimeout(() => 
              {
                  if (self && !self._isDestroyed)
                      self.checkHttpReturn(id);
              }, configTime);      
             axios.get(shareCard+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&mode="+newCid)
             .then(res=>{  
                httpSendQue[id] = 1; 
                this.Toast.close();
                if(res.data.s==0){
                     this.haveOne=false;
                     this.invit=res.data.list
                }
                else if(res.data.s==1010)
                {
                     this.haveOne=true;
                }
                  })
            .catch(error=>{
                 this.Toast.close()
                         Toast({
                              message: '网络不给力',
                              position: 'middle',
                              duration:2000
                            })            
                        })
           var newCid = '"' + "cid" + '":' + '"' + newCid + '"';
           console.log(newCid)
           ws.send('{"action":"ShareCardListByUid",'+newCid+'}');
           ws.onmessage = (res)=> 
               { 
               var obj = JSON.parse(res.data);
                  console.log(obj);  
                  this.$store.commit("sharCard",obj)
                  if(obj.s==0){
                      this.haveOne=false;
                     this.invit=obj.list
                  }    
               }
         
       },
        sure() {
            if(this.phone===this.phoneNum){
                      Toast('不可邀请自己');
            }else{
                    var reguOne = /^1\d{10}$/;
                      if (reguOne.test(this.phone)) {
                            MessageBox.prompt(' ', '请输入你的六位支付密码').then(({ value }) => {
                              if (value) {
                                  // alert(value)
                                  // MessageBox.alert("邀请成功");
                                          // cid
                            var newCid=this.$route.query.cidNew;
                            var newCid = '"' + "cid" + '":' + '"' + newCid + '"';
                            //sid
                              var newSid=this.$route.query.sid;
                              var newSid='"' + "sid" + '":' + '"' + newSid + '"';
                              // 手机号
                              var newPhone=this.phone
                              var newPhone='"' + "mobile" + '":' + '"' + newPhone + '"';
                              //  支付密码 
                              var newPassword=md5(value)
                              var newPassword='"' + "password" + '":' + '"' + newPassword + '"';
                              console.log(newCid,newSid,newPhone,newPassword)
                            ws.send('{"action":"GetMobileLoginVerifyCodeIsUsedToInviteShareCard",'+newCid+','+newSid+','+newPhone+','+newPassword+'}');
                             ws.onmessage = (res)=> 
                                { 
                                var obj = JSON.parse(res.data);
                                    console.log(obj);   
                                    if(obj.s==0){
                                        this.websocketTne();
                                    

                                    }  
                                    if(obj.s==0 && obj.action=="GetMobileLoginVerifyCodeIsUsedToInviteShareCard"){
                                              MessageBox.alert("邀请成功");
                                    }else if(obj.s==2014){
                                                  Toast('请输入您正确的6位数密码');
                                    }
                                    if(obj.s==2014){
                                    
                                    }  
                                }
                                }
                              });
                        }else{
                  Toast('请输入正确的手机号');
            }
            
                
              
              
            } 
            
          }
          
        },
          created() 
          {
            // 获取会员卡共享者列表
                   this.websocketTne();
                      if (this.zhekou == 10) {
                        this.isZhekou = false;
                      }
                      var str=this.$route.query.cShowId
                      var strOne = str.replace(/(\d{4})/g, "$1 ").replace(/\s*$/, "")
                      this.cShowId=strOne                    　
          },
          destroyed()
          {
            this.Toast.close()
          
          },
          mounted(){
            var cardStyleId=localStorage.getItem("cardStyleId")
            if(cardStyleId==3)
            {
              this.bgSrc=require("../../assets/images/bg-three.png")
            }
            else if(cardStyleId==2)
            {
                this.bgSrc=require("../../assets/images/bg-one.jpg")
            }
            else if(cardStyleId==1)
            {
                this.bgSrc=require("../../assets/images/bg-two.jpg")
            }
          }
};

</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.8rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
.rightOne{
  white-space:nowrap;
   text-overflow:ellipsis;
   overflow: hidden;
   display: inline-block;
   width:7.2rem
}
.right{
  margin-left: 1.8rem;
  color: rgba(0, 0, 0, 0.8);
}
.newUl{
  color: rgba(0, 0, 0, 0.8)
}
.newUl li{
  margin-bottom: 0.2rem
}
#panduan {
  font-size: 0.3rem;
  height: 1rem;
  line-height: 1rem;
  color: white;
  font-size: 0.3rem;
  margin-top: 0;
}
p {
  font-size: 0.4rem;
  color: #000000;
  text-align: center;
  font-weight: 530;
  margin-top: 0.36rem;
}
.myFriend{
  margin-top:0.8rem !important
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  /* position: relative; */
   position: fixed;
  top: 0;
  left: 0;
  background: white
}
.juzhong{
   height: 1.6rem;
  width: 100%;
}
.cardNumber {
  font-size: 0.5rem;
  position: absolute;
  top: 6.5rem;
  left: 0.6rem;
  color: white;
}
.headerOne {
  font-size: 0;
}
.remind{
  color: red
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
ul#ulOne li {
  width:95%;
  height:6rem;
  background: red;
  margin: 0.2rem auto;
  border-radius: 0.4rem;
  background-image: url("../../assets/images/bg-three.png");
  background-repeat: no-repeat;
  background-size: 100% 6rem;

  font-size: 0;
  /* position: relative; */
}
ul li img {
  width: 1rem;
  height: auto;
  vertical-align: middle;
  margin-left: 0.6rem;
}
ul li .card {
  font-size: 0.5rem !important;
  vertical-align: middle;
  color: white;
  margin-left: 0.2rem;
}
ul li img {
  /* width: 0.6rem;
  height: auto;
  vertical-align: middle;
  margin-left: 0.6rem; */
}
ul li .card {
  font-size: 0.35rem;
  vertical-align: middle;
  color: white;
  margin-left: 0.2rem;
}
img,
.card {
  display: inline-block;
  margin-top: 0.2rem;
}
.discount3 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background: #e80000;
  float: right;
  /* margin-right: 1.5rem; */
  border-radius: 0.12rem;
  margin-right: 0.6rem
  /* top: 0;
  left:7.4rem; */
}
.discount3 .cententOne {
  text-align: center;
}
.discount3 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.25rem;
  /* margin-bottom: 0.35rem */
}
.discount3 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  /* height: 0.7rem; */
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount3 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}
.discount3 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

.discount2 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background:  #A4AC10;
  float: right;
  /* margin-right: 1.5rem; */
  border-radius: 0.12rem;
  margin-right: 0.6rem
  /* top: 0;
  left:7.4rem; */
}
.discount2 .cententOne {
  text-align: center;
}
.discount2 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.25rem;
  /* margin-bottom: 0.35rem */
}
.discount2 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  /* height: 0.7rem; */
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount2 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}
.discount2 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

.discount1 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background:  #85C4B5;
  float: right;
  /* margin-right: 1.5rem; */
  border-radius: 0.12rem;
  margin-right: 0.6rem
  /* top: 0;
  left:7.4rem; */
}
.discount1 .cententOne {
  text-align: center;
}
.discount1 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.25rem;
  /* margin-bottom: 0.35rem */
}
.discount1 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  /* height: 0.7rem; */
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount1 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}
.discount1 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

.payment {
  font-size: 0.55rem;
  font-weight: bold;
  text-align: center;
  margin-top: 1rem;
}
.share {
  font-size: 0.55rem;
}
.share div:nth-child(1),
.share div:nth-child(2) {
  text-align: center;
  margin-top: 0.15rem;
}
input::-webkit-input-placeholder {  

font-size: 0.55rem;
 color: rgba(0, 0, 0, 0.5)
} 
.share input {
  border: none;
  outline: none;
  font-size: 0.55rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
 width:5rem;
 text-indent: 0.3rem;
  height: 1rem;
}
.share div:nth-child(1) span {
  margin-right: 0.3rem;
}
.share div:nth-child(2) span {
  /* margin-right: 0.3rem */
}
/* .share div:nth-child(1){
        position: relative;
    } */

.inviteOne {
  width:5.5rem;
  height:1.2rem;
  background-image: linear-gradient(to right, #2ea4b0, #06789d);
  color: white;
  font-size: 0.55rem;
  text-align: center;
  line-height:1.2rem;
  border-radius: 12px;
  margin: 0 auto;
  margin-top: 0.4rem;
}
.people {
  font-size: 0.55rem;
  color: black;
  margin: 1rem 0 0.1rem 0.6rem;
}
.noneOne {
  font-size: 0.45rem;
  color: rgba(0, 0, 0, 0.2);
  margin: 0.2rem 0 0.1rem 0.58rem;
}

</style>



// WEBPACK FOOTER //
// src/components/invite/invite.vue